import { render, staticRenderFns } from "./home-links.vue?vue&type=template&id=137ba114&"
import script from "./home-links.vue?vue&type=script&lang=js&"
export * from "./home-links.vue?vue&type=script&lang=js&"
import style0 from "./home-links.vue?vue&type=style&index=0&id=137ba114&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports